<template lang="pug">
  ods-main-header(
    :headerLogoText="productName"
    logoUrl="/"
    breadcrumbSeparator=">"
    actionsMenuIcon="overflow-menu"
    :showSuitesMenu="false"
    :showBreadcrumbs="true"
    :environment="env"
    :showActionsMenu="false"
    :showUserMenu="true")
    template(slot="actions")
      header-actions
    template(slot="userAvatar")
      img(src="@/assets/images/header/avatar.svg")
    template(slot="user")
      user-menu
    template(slot="suites")
      suites-menu

</template>

<script>
import HeaderActions from '@/components/header/HeaderActions'
import UserMenu from '@/components/header/UserMenu'
import SuitesMenu from '@/components/header/SuitesMenu'
import HeaderCustomContent from '@/components/header/HeaderCustomContent'
import cssVars from '@/assets/scss/base/_variables.scss'

export default {
  name: 'HeaderContent',
  components: {
    HeaderActions,
    UserMenu,
    SuitesMenu,
    HeaderCustomContent
  },

  data () {
    return {
      cssVars: cssVars
    }
  },

  computed: {
    env () {
      return `${process.env.VUE_APP_ENV_TAG} ${process.env.VUE_APP_VERSION_TAG}`
    },

    productName () {
      return process.env.VUE_APP_PRODUCT_NAME
    }
  }
}
</script>

<style lang="scss" scoped>
  .ods-main-header__client-logo {
    width: 100px;
    img {
      width: 100%;
      max-width: 100%;
    }
  }

  /deep/ .ods-main-header {
    border-bottom: 1px solid #d4dcdf;
    box-shadow: none;
  }
</style>
